import React from "react";
import { Button, Modal, Form } from "semantic-ui-react";

const ProfileFormModal = ({
  editStatus,
  openFormModal,
  formData,
  onChangeFormItem,
  onCloseFormModal,
  onSaveProfile,
}) => {
  return (
    <Modal
      closeIcon
      size="small"
      open={openFormModal}
      onClose={onCloseFormModal}
    >
      <Modal.Header>{editStatus ? "Edit Profile" : "Add Profile"}</Modal.Header>
      <Modal.Content>
        <Form>
          <Form.Field required>
            <label>Platform</label>
            <Form.Input
              fluid
              disabled
              placeholder="Platform"
              value={formData.MES}
            />
          </Form.Field>
          <Form.Field required>
            <label>Scope</label>
            <Form.Input
              fluid
              disabled
              value={formData.scope}
              placeholder="Scope"
            />
          </Form.Field>
          <Form.Field required>
            <label>Stage</label>
            <Form.Input
              fluid
              disabled
              value={formData.stage}
              placeholder="Stage"
            />
          </Form.Field>
          <Form.Field required>
            <label>Host</label>
            <Form.Input
              fluid
              disabled
              placeholder="Host"
              value={formData.host}
            />
          </Form.Field>
          <Form.Field required>
            <label>Profile Name</label>
            <Form.Input
              required
              placeholder="Profile Name"
              value={formData.name}
              error={!formData.nameValid}
              onChange={(_e, { value }) => onChangeFormItem("name", value)}
            />
          </Form.Field>
          <Form.Field>
            <label>Description</label>
            <Form.TextArea
              placeholder="Description"
              value={formData.description}
              onChange={(_e, { value }) =>
                onChangeFormItem("description", value)
              }
            />
          </Form.Field>
        </Form>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={onCloseFormModal}>Cancel</Button>
        <Button type="submit" positive onClick={onSaveProfile}>
          Save
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export { ProfileFormModal };
